export const settingsRoutes = {
    main: {
        route: '/settings',
        get: () => '/settings',
    },
    overview: {
        route: '/settings/overview',
        get: () => `/settings/overview`,
    },
    account: {
        route: '/settings/account',
        get: () => `/settings/account`,
    },
    security: {
        main: {
            route: '/settings/security',
            get: () => `/settings/security`,
        },
        password: {
            route: '/settings/security/password',
            get: () => `/settings/security/password`,
        },
        delete: {
            route: '/settings/security/delete',
            get: () => `/settings/security/delete`,
        },
    },
    billing: {
        main: {
            route: '/settings/billing',
            get: () => `/settings/billing`,
        },
        credits: {
            route: '/settings/billing/credits',
            get: () => `/settings/billing/credits`,
        },
        coins: {
            route: '/settings/billing/coins',
            get: () => `/settings/billing/coins`,
        },
    },
    earnings: {
        route: '/settings/earnings',
        get: () => `/settings/earnings`,
    },
};
//# sourceMappingURL=settings.js.map